import { powerSyncCollectionOptions } from "@tanstack/powersync-db-collection";
import { createCollection } from "@tanstack/react-db";
import { z } from "zod";
import { AppSchema } from "@/lib/powersync-schema.generated";
import { collectionBase } from "./_factory";
import { syncedRow } from "./synced-row";

export const SelectReservationUnitSchema = syncedRow({
  createdAt: z.string(),
  id: z.string(),
  propertyId: z.string(),
  reservationId: z.string(),
  unitId: z.string().nullable(),
  updatedAt: z.string(),
});

export type ReservationUnit = z.infer<typeof SelectReservationUnitSchema>;

export const reservationUnitsCollection = createCollection(
  powerSyncCollectionOptions({
    ...collectionBase("reservation unit"),
    schema: SelectReservationUnitSchema,
    table: AppSchema.props.reservation_units,
  })
);
